import { WatchLaterList } from '../features/watchLater/components/WatchLaterList';
import useWootricSurvey from '../hooks/useWootricSurvey';
import { jsx as _jsx } from "react/jsx-runtime";
export const WatchLater = () => {
  useWootricSurvey('CSAT');
  return /*#__PURE__*/_jsx(WatchLaterList, {});
};
export default WatchLater;